export const lanesInitialFilters = {
  status: "",
  id:"",
  capturePlace: "",
  route: "",
  laneDescription: "",
  laneObservation: "",
  maintenanceGroup: [],
  type: "",
}

export function statusComparator(a, b){
  const value = {
    true: 1,
    alert: 2,
    false: 3
  };

  const va = value[a] ?? 10;
  const vb = value[b] ?? 10;

  return va - vb;
}

export function applyInitialSort(api) {
  const defaultSortModel = [
    { colId: 'capturePlace', sort: 'asc', sortIndex: 0 },
    { colId: 'id', sort: 'desc', sortIndex: 1 }
  ];

  api.applyColumnState({
    state: defaultSortModel,
    defaultState: { sort: null }
  });
}

export function mergeLatestPassage(lane, latestPassage) {
  if (!latestPassage) {
    return {
      ...lane,
      latestPassageInfo: null,
      latestPassageDatetime: "",
      latestPassageUrl: "",
      dtLastPassage: "",
    };
  }

  const latestPassageDatetime = latestPassage.latestPassageDatetime || latestPassage.captureTime || "";
  const latestPassageUrl = latestPassage.latestPassageUrl || latestPassage.url || "";

  return {
    ...lane,
    latestPassageInfo: latestPassage,
    latestPassageDatetime,
    latestPassageUrl,
    dtLastPassage: latestPassageDatetime,
  };
}
